import ApiService from '../common/api.service';

import {
  FETCH_ACCESOS,
  CLEAR_ACCESOS_ACTION,
  SEND_ENTRY,
  CANCEL_ACCESO_ACTION,
  FETCH_ACCESO_DETALLES,
} from './actions.type';

import {
  SET_ACCESOS,
  CLEAR_ACCESOS,
  SET_ERROR,
  FETCHING_ACCESOS,
  FETCHED_ACCESOS,
  CANCELLED_ACCESO,
  CANCELLING_ACCESO,
  RESET_REVOKE_SUBMIT,
  SENT_CANCEL_ACCESO,
  SET_ACCESO_DETALLES,
  CLEAR_ACCESOS_DETALLES,
  FETCHING_ACCESO_DETALLES,
  FETCHED_ACCESO_DETALLES,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  accesos_list: [],
  loading_accesos: false,
  getted_detalles: false,
  sending_revoke: false,
  revoke_sent: false,
  alert: false,
  alertMessage: '',
  alertType: 'success',
  accesos_detalles: [],
  accesos_total: 0,
};

const getters = {
  getted_detalles(state) {
    return state.getted_detalles;
  },
  accesos_detalles(state) {
    return state.accesos_detalles;
  },
  accesos_list(state) {
    return state.accesos_list;
  },
  accesos_total(state) {
    return state.accesos_total;
  },
  loading_accesos(state) {
    return state.loading_accesos;
  },
  sending_revoke(state) {
    return state.sending_revoke;
  },
  revoke_sent(state) {
    return state.revoke_sent;
  },
  revoke_alert(state) {
    return state.alert;
  },
  revoke_alertMessage(state) {
    return state.alertMessage;
  },
  revoke_alertType(state) {
    return state.alertType;
  },
};

const actions = {
  [FETCH_ACCESO_DETALLES](context, accesoId) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.query(`accesos/access_detail/${accesoId}`)
        .then(({ data }) => {
          context.commit(SET_ACCESO_DETALLES, data);
          context.commit(FETCHED_ACCESO_DETALLES);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_ACCESO_DETALLES);
        });
    });
  },
  [FETCH_ACCESOS](context, data) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESOS);
      ApiService.setHeader();
      ApiService.post('accesos', data)
        .then(({ data }) => {
          context.commit(SET_ACCESOS, data);
          context.commit(FETCHED_ACCESOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_ACCESOS);
        });
    });
  },
  [CLEAR_ACCESOS_ACTION](context) {
    context.commit(CLEAR_ACCESOS);
  },
  [CANCEL_ACCESO_ACTION](context, data) {
    context.commit(RESET_REVOKE_SUBMIT);
    return new Promise((resolve) => {
      context.commit(CANCELLING_ACCESO);
      ApiService.setHeader();
      ApiService.post('accesos/revoke_acceso', {
        acceso_id: data.accesoId,
        motivo: data.motivo,
      })
        .then(({ data }) => {
          context.commit(CANCELLED_ACCESO);
          context.dispatch(FETCH_ACCESOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(SENT_CANCEL_ACCESO);
        });
    });
  },
  [SEND_ENTRY](context, data) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESOS);
      ApiService.setHeader();
      const toSend = {
        operador_id: data.operador_id,
        fecha_detalle: data.fecha_detalle,
        hora_detalle: data.hora_detalle,
        portico: data.portico,
        status_acceso: data.status_acceso,
        observaciones: data.observaciones,
        acceso_id: data.acceso_id,
      };
      ApiService.post('accesos/access_registration', toSend)
        .then(({ data }) => {
          context.commit(FETCHED_ACCESOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_ACCESOS);
        });
    });
  },
};

const mutations = {
  [FETCHING_ACCESO_DETALLES](state) {
    state.getted_detalles = false;
  },
  [FETCHED_ACCESO_DETALLES](state) {
    state.getted_detalles = true;
  },
  [CLEAR_ACCESOS_DETALLES](state) {
    state.accesos_detalles = [];
    state.getted_detalles = false;
  },
  [SET_ACCESO_DETALLES](state, data) {
    state.accesos_detalles = data.detalle;
  },
  [SET_ACCESOS](state, data) {
    state.accesos_list = data.accesos;
    state.accesos_total = data.total;
  },
  [CLEAR_ACCESOS](state) {
    state.accesos_list = [];
    state.accesos_total = 0;
  },
  [FETCHING_ACCESOS](state) {
    state.loading_accesos = true;
  },
  [FETCHED_ACCESOS](state) {
    state.loading_accesos = false;
  },
  [CANCELLING_ACCESO](state) {
    state.sending_revoke = true;
  },
  [SENT_CANCEL_ACCESO](state) {
    state.sending_revoke = false;
  },
  [CANCELLED_ACCESO](state) {
    state.sending_revoke = false;
    state.revoke_sent = true;
  },
  [RESET_REVOKE_SUBMIT](state) {
    state.sending_revoke = false;
    state.revoke_sent = false;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
